import { FilterSelect } from '@/components/shared/FilterSelect/FilterSelect';
import { ContentStatus } from '@addmile/backend-client';

import { CONTENT_STATUS } from '../../../Content/const';
import { STATUS_HINTS } from '../../const';

interface JourneyStatusSelectProps {
  status: ContentStatus;
  onChange: (status: ContentStatus) => void;
  withHints?: boolean;
  label?: string;
}

const JourneyStatusSelect = ({ status, onChange, withHints, label }: JourneyStatusSelectProps) => (
  <FilterSelect
    label={label}
    labelClassName="font-semibold text-neutral-80"
    value={status}
    onChange={(value) => onChange(value as ContentStatus)}
    options={CONTENT_STATUS.map(({ value, label, icon, color }) => ({
      value,
      label: withHints ? `${label} (${STATUS_HINTS[value]})` : label,
      icon,
      color,
    }))}
  />
);

export default JourneyStatusSelect;
